import { render } from "./CaseMainPageMobile.vue?vue&type=template&id=54d4583f"
import script from "./CaseMainPageMobile.vue?vue&type=script&lang=js"
export * from "./CaseMainPageMobile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__